import React, {PureComponent} from 'react';
import {
    DispensingOrdersFuelsStock,
    DispensingOrdersViewState,
    IDispensingOrder,
    IDispensingOrdersState
} from "../components/DispensingOrders/models";
import {DispensingOrdersSearchBar} from '../components/DispensingOrders/DispensingOrdersSearchBar';
import {AuthenticationContext} from "../services/context/authentication.context";
import {DispensingOrdersForm} from "../components/DispensingOrders/DispensingOrdersForm";
import {DispensingOrdersService} from "../components/DispensingOrders/DispensingOrders.service";
import {Button, OverlayTrigger, Popover, Spinner} from "react-bootstrap";
import {dateFormatOptions} from "../common/dateFormatterConfig";
import { PageProps } from 'models/page';
import { LOCAL_STORAGE_KEYS } from 'common/constants/localStorageKeys';

export class DispensingOrders extends PureComponent<PageProps, IDispensingOrdersState> {

    static contextType = AuthenticationContext;

    constructor(props: PageProps) {
        super(props);
        this.state = {
            customerId: Number(localStorage.getItem(LOCAL_STORAGE_KEYS.CUSTOMER_ID)),
            loading: true,
            dispensingOrderFuels: [],
            dispensingOrders: [],
            viewState: DispensingOrdersViewState.VIEW,
            fuelStock: DispensingOrdersFuelsStock.COMMERCIAL
        };
        this.props.onLoadValidatePage();
    }

    onViewChange = (view: DispensingOrdersViewState) => {
        this.setState({viewState: view},() => {});
    };

    onStockChange = (stock: DispensingOrdersFuelsStock) => {
        this.setState({
            fuelStock: stock
        });
    };

    getDispensingOrders = () => {
        if (this.state.customerId === null)
            return;

        this.setState({
            loading: true
        });

        DispensingOrdersService.getDispensingOrders(this.state.customerId).then((response: Array<IDispensingOrder>) => {
            this.setState({
                ...this.state,
                loading: false,
                dispensingOrders: response
            });
        }).catch(error => {
            console.error(error);
            this.setState({
                loading: false,
            });
        })
    };

    updateCustomerId = () => {
        if (this.context.state.customerId !== this.state.customerId) {
            this.setState({
                ...this.state,
                loading: true,
                customerId: this.context.state.customerId,
            }, () => {
                this.getDispensingOrders();
            });
        }
    };

    editDispensingOrder = (uid: string) => {
        const editOrder = this.state.dispensingOrders.find(order => order.uid === uid);
        if (!editOrder)
            return;

        this.setState({editingDispensingOrder: editOrder});
        this.onViewChange(DispensingOrdersViewState.EDIT)
};

    componentDidMount(): void {
        this.getDispensingOrders();
    }

    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<IDispensingOrdersState>, snapshot?: any): void {
        this.updateCustomerId();
    }

    render() {
        const tableRows = this.state.dispensingOrders.map(row => (
            <tr key={row.uid}>
                <td></td>
                <td>{row.authorizationNumber}</td>
                <td>{row.transporterName}</td>
                <td>{row.carRegNumber}</td>
                <td>{row.trailerRegNumber ? row.trailerRegNumber : '-'}</td>
                <td>{row.driverName}</td>
                <td>
                    <OverlayTrigger
                        trigger={["hover", "focus"]}
                        placement={"top"}
                        delay={300}
                        overlay={
                            <Popover id="product-rows id">
                                <Popover.Title as="h4" className="text-primary">Tooted</Popover.Title>
                                <Popover.Content>
                                    <table className="small">
                                        <thead>
                                        <tr>
                                            <th>Nimetus</th>
                                            <th>Kogus</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {row.productRows.filter(row => row.quantity > 0).map(row =>
                                            <tr key={row.rowNumber}>
                                                <td>{row.productName}</td>
                                                <td className="text-nowrap">{row.quantity} L</td>
                                            </tr>)}
                                        </tbody>
                                    </table>

                                </Popover.Content>
                            </Popover>
                        }>
                        <div className="d-flex align-items-center">
                            <span>{row.productRows ? row.productRows.filter(row => row.quantity > 0).length : 0} tk</span>
                            <i className={'icon--16 ml-2 icon__info '} />
                        </div>
                    </OverlayTrigger>
                </td>
                <td>{row.validUntil ? new Intl.DateTimeFormat('et', dateFormatOptions).format(new Date(row.validUntil)) : "-"}</td>

                <td>{row.documentStateName}</td>
                <td>
                    {
                        row.isModifiable &&
                        <Button
                            variant="outline-primary"
                            size="sm"
                            type="button" onClick={() => this.editDispensingOrder(row.uid)}>
                            Muuda
                        </Button>
                    }
                </td>
            </tr>
        ));
        return (
            <div className="document-rows__container">

                <DispensingOrdersSearchBar
                    onViewChange={this.onViewChange}
                    viewState={this.state.viewState}
                    onFuelStockChange={this.onStockChange}/>
                {/*<div className="row">*/}
                {/*    <div className="col">*/}
                {
                    this.state.loading &&
                    <div className="text-center"><Spinner animation={"grow"}/></div>
                }

                {
                    !this.state.loading &&
                    <>
                        {
                            this.state.viewState === DispensingOrdersViewState.VIEW &&
                            <div className="table__container scroll-icon-md">
                                <table className="table table-responsive-md dispensing-orders__table table-hover ">
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th>ALUSDOKUMENT</th>
                                        <th>VEDAJA</th>
                                        <th>AUTO</th>
                                        <th>HAAGIS</th>
                                        <th>JUHT</th>
                                        <th>TOOTED</th>
                                        <th>KEHTIB KUNI</th>
                                        <th>STAATUS</th>
                                        <th></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        {tableRows}
                                    </tbody>
                                </table>
                            </div>
                        }
                        {
                            (this.state.viewState === DispensingOrdersViewState.NEW
                                || this.state.viewState === DispensingOrdersViewState.EDIT) &&
                            <DispensingOrdersForm
                                viewState={this.state.viewState}
                                editingDispensingOrder={this.state.editingDispensingOrder}
                                onFuelStockChange={this.onStockChange}
                                fuelStock={this.state.fuelStock}
                                onSubmitReload={() => {
                                    this.getDispensingOrders();
                                    this.onViewChange(DispensingOrdersViewState.VIEW);
                                }
                                }/>
                        }
                    </>
                }
                {/*</div>*/}
                {/*</div>*/}
            </div>
        );
    }
}
